import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AboutSection() {
  const stats = [
    { value: '10,000+', label: 'Clients Served', icon: 'ri-user-heart-line' },
    { value: '15+', label: 'Years Experience', icon: 'ri-award-line' },
    { value: '2', label: 'Trusted Brands', icon: 'ri-building-2-line' },
    { value: '5', label: 'Cities Covered', icon: 'ri-map-pin-2-line' },
  ];

  return (
    <section id="about" className="py-24 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden border border-amber-500/20">
              <img
                src="https://public.readdy.ai/ai/img_res/494ce08de229a895523732353b40b9d4.jpg"
                alt="About Villarreal Enterprise Group"
                className="w-full h-[480px] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-950/60 via-transparent to-transparent"></div>
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-5 -right-5 bg-gray-950 border border-amber-500/30 rounded-xl p-5 shadow-2xl">
              <div className="text-3xl font-bold text-amber-400">A+</div>
              <div className="text-xs text-gray-400 mt-1">Rated Service</div>
            </div>
            {/* Gold corner accent */}
            <div className="absolute -top-3 -left-3 w-16 h-16 border-t-2 border-l-2 border-amber-500/50 rounded-tl-xl"></div>
            <div className="absolute -bottom-3 -right-3 w-16 h-16 border-b-2 border-r-2 border-amber-500/50 rounded-br-xl"></div>
          </div>

          {/* Right: Content */}
          <div>
            <div className="inline-flex items-center px-4 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/25 mb-6">
              <i className="ri-building-2-line text-amber-400 mr-2 text-sm"></i>
              <span className="text-xs font-semibold text-amber-400 tracking-widest uppercase">About Us</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              About{' '}
              <span className="bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
                Villarreal
              </span>{' '}
              Enterprise Group
            </h2>

            <div className="flex items-center gap-3 mb-6">
              <div className="h-px w-10 bg-amber-500/50"></div>
              <i className="ri-star-fill text-amber-500 text-xs"></i>
              <div className="h-px w-10 bg-amber-500/50"></div>
            </div>

            <p className="text-gray-300 mb-5 leading-relaxed">
              As the parent company of{' '}
              <strong className="text-amber-400">Speedy DMV Services™</strong> and{' '}
              <strong className="text-amber-400">DMV-Xpress Services™</strong>, we provide a foundation
              of operational support, community commitment, and service excellence to help our companies
              serve thousands of clients across the Las Vegas Valley.
            </p>
            <p className="text-gray-400 mb-5 leading-relaxed">
              With decades of combined experience, our companies share one mission: to make DMV and
              paperwork processes faster, easier, and more human-friendly for all Nevadans.
            </p>
            <p className="text-sm text-amber-500/60 italic mb-8">
              Operated by The Villarreal Organization, Inc
            </p>

            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {stats.map((stat, i) => (
                <div
                  key={i}
                  className="bg-gray-950 border border-gray-800 hover:border-amber-500/30 rounded-xl p-4 transition-all duration-300 group"
                >
                  <div className="w-8 h-8 flex items-center justify-center mb-2">
                    <i className={`${stat.icon} text-xl text-amber-400`}></i>
                  </div>
                  <div className="text-2xl font-bold text-amber-400 mb-1">{stat.value}</div>
                  <div className="text-gray-500 text-xs tracking-wide">{stat.label}</div>
                </div>
              ))}
            </div>

            <Link to="/about">
              <Button variant="primary" size="md">
                <i className="ri-information-line mr-2"></i>
                Learn Our Story
                <i className="ri-arrow-right-line ml-2"></i>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
